import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import { connect } from 'react-redux';
import uuid from '@cotyorg/ccx-utils/js/helpers/uuid';
import { matchImageWithBreakpoint } from '@cotyorg/ccx-server/hydrate/helpers/images';
import {
  initVideo as initVideoAction,
  setTogglePlayPause as setTogglePlayPauseAction,
  setVolume as setVolumeAction,
  setToggleMuted as setToggleMutedAction,
  setProgress as setProgressAction,
  setDuration as setDurationAction,
  setSeeking as setSeekingAction,
  setFullScreen as setFullScreenAction,
  setStopped as setStoppedAction,
  setMilestone as setMilestoneAction,
  resetMilestone as resetMilestoneAction,
  setMediaPlay as setMediaPlayAction,
} from '../modules';

class VideoContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.id = uuid();
  }

  render() {
    const {
      videos = {},
      videoContent,
      videosStoreDataKey,
      childComponent: ChildComponent,
      currentBreakpoint,
    } = this.props;

    const posterImage = matchImageWithBreakpoint({
      currentBreakpoint,
      image: videoContent[`${videosStoreDataKey}`],
    });

    return (
      <ChildComponent
        id={this.id}
        {...this.props}
        {...videos[this.id]}
        videoData={videoContent[`${videosStoreDataKey}`]}
        posterImage={posterImage}
      />
    );
  }
}

const mapStateToProps = ({ videos, content, breakpoints }) => ({
  currentBreakpoint: R.prop('current', breakpoints),
  videoContent: R.prop('videos')(content),
  videos,
});

const mapDispatchToProps = dispatch => ({
  initVideo: (muted, volume, id) => dispatch(initVideoAction(muted, volume, id)),
  setTogglePlayPause: id => dispatch(setTogglePlayPauseAction(id)),
  setVolume: (volume, id) => dispatch(setVolumeAction(volume, id)),
  setToggleMuted: id => dispatch(setToggleMutedAction(id)),
  setProgress: (progress, id) => dispatch(setProgressAction(progress, id)),
  setDuration: (duration, id) => dispatch(setDurationAction(duration, id)),
  setSeeking: (seeking, id) => dispatch(setSeekingAction(seeking, id)),
  setFullScreen: (isFullScreen, id) => dispatch(setFullScreenAction(isFullScreen, id)),
  setStopped: id => dispatch(setStoppedAction(id)),
  setMilestone: payload => dispatch(setMilestoneAction(payload)),
  resetMilestone: payload => dispatch(resetMilestoneAction(payload)),
  setMediaPlay: id => dispatch(setMediaPlayAction(id)),
});

VideoContainer.propTypes = {
  childComponent: PropTypes.func.isRequired,
  videosStoreDataKey: PropTypes.string.isRequired,
  videos: PropTypes.objectOf(PropTypes.any),
  videoContent: PropTypes.arrayOf(PropTypes.any),
  currentBreakpoint: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoContainer);
